<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Charged Energy (accumulated)" chart.
    </rb-callout>
</div>
<div id="charged-energy-ef-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of accumulated charged energy since start of service for the entire fleet + the selected EV
    </div>
</div>